import React from 'react';

const CommentElement = (props) => {
  return (
    <div className='dynamic-report-item'>
      <div className='label' style={{whiteSpace: 'pre-wrap'}}>
        {props.prompt}
      </div>
      {props.author && (
        <div style={{color: '#22358d'}}><i>{props.author} Commented</i></div>
      )}
      <div className='field' style={{whiteSpace: 'pre-wrap'}}  dangerouslySetInnerHTML={{__html: props.comment}}>
      </div>
    </div>
  );
};

export default CommentElement;
